export const SALES_PLAN_DETAIL_FIELDS_NUMBER = '5_1_5';
export const PRODUCTION_PLANS_FIELDS_NUMBER = '6_7_1';
export const REVENUE_PLANS_FIELDS_NUMBER = '11_3_1';